import React from 'react';

import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter
} from '@material-ui/core';

import { StyledTableCell, StyledTableRow } from 'components/StyledComponents';
import LinkComponent from 'components/LinkComponent/LinkComponent';

import { LOOSE_ITEM_DETAILED_PATH } from 'constants/routeConstants';

import styles from './LooseItemsTable.module.scss';

import { formatPrice } from 'helpers/AppHelpers';

const LooseItemsTable = ({ currentConfiguration }) => {
  const calculateTotals = () => {
    if (
      !currentConfiguration ||
      !currentConfiguration.looseItems ||
      !currentConfiguration.looseItems.length
    )
      return { totalQuantity: 0, totalCost: 0 };

    let totalQuantity = 0;
    let totalCost = 0;

    currentConfiguration.looseItems.forEach((item) => {
      const quantity = Number(item.quantity) || 0;
      const price = Number(item.pricePerUnit) || 0;

      totalQuantity += quantity;
      totalCost += quantity * price;
    });

    return { totalQuantity, totalCost };
  };

  const { totalQuantity, totalCost } = calculateTotals();

  return (
    <TableContainer className={styles.tableContainer} component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell className={styles.firstRow}>Loose Item</StyledTableCell>
            <StyledTableCell>Quantity</StyledTableCell>
            <StyledTableCell className={styles.priceRow}>Price Per Unit</StyledTableCell>
            <StyledTableCell className={styles.lastRow}>Total cost of units</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentConfiguration?.looseItems?.length ? (
            currentConfiguration.looseItems.map((row) => (
              <StyledTableRow key={row.id}>
                <StyledTableCell className={styles.cell}>
                  <LinkComponent path={`${LOOSE_ITEM_DETAILED_PATH}/${row.id}`} name={row.name} />
                </StyledTableCell>
                <StyledTableCell align="left">
                  <span>{row.quantity || 0}</span>
                </StyledTableCell>
                <StyledTableCell align="left">
                  <span>{formatPrice(row.pricePerUnit || 0)}</span>
                </StyledTableCell>
                <StyledTableCell align="left">
                  <span>{formatPrice((row.quantity || 0) * (row.pricePerUnit || 0))}</span>
                </StyledTableCell>
              </StyledTableRow>
            ))
          ) : (
            <StyledTableRow>
              <StyledTableCell colSpan={4} className={styles.emptyTable}>
                No available data in the table.
              </StyledTableCell>
            </StyledTableRow>
          )}
        </TableBody>
        {currentConfiguration?.looseItems?.length > 0 && (
          <TableFooter>
            <StyledTableRow className={styles.total_row}>
              <StyledTableCell>
                <strong>Total</strong>
              </StyledTableCell>
              <StyledTableCell>
                <strong>{totalQuantity}</strong>
              </StyledTableCell>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell>
                <strong>{formatPrice(totalCost)}</strong>
              </StyledTableCell>
            </StyledTableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
};

export default LooseItemsTable;
